<template>
    <div class="front-container">
      <div class="logo"></div>
      <div class="front-container-inner">
        <div v-if="active == 'login'">
          <login></login>
        </div>
        <div v-if="active == 'register'">
          <register></register>
        </div>
        <div v-if="active == 'reset'">
          <reset></reset>
        </div>
        <div v-if="active == 'recovery'">
          <recovery></recovery>
        </div>
        <div class="bottom-links">
          <a href="javascript:void(0)" @click="setActive('register')" v-if="active != 'register'">
            {{ $t('Register') }}
          </a>
          <a href="javascript:void(0)" @click="setActive('login')" v-if="active != 'login'">
            {{ $t('Login') }}
          </a>
          <a href="javascript:void(0)" class="text-center" @click="setActive('recovery')" v-if="active != 'recovery'">
            {{ $t('Forgot password') }}
          </a>
          <a href="javascript:void(0)" @click="setLocale($i18n.locale == 'en' ? 'de' : 'en')">
            <i class="fa fa-globe"></i> {{ $i18n.locale == 'en' ? 'Deutsche' : 'English' }}
          </a>
        </div>
      </div>
      <p class="dd-mlink">Designed & Developed by <a href="https://m-link.co" target="_blank">MLink</a></p>
<!--        <content-page></content-page>-->
    </div>
</template>

<script>
import HeaderFront from './HeaderFront.vue'
import ContentFront from './ContentFront.vue'
import axios from 'axios'
import Register from "./Register.vue";
import Login from "./Login.vue";
import Reset from "./Reset.vue";
import Recovery from "./Recovery.vue";
import {mapState} from "vuex";

export default {
    name: "front-page",
    components: {
        'header-top': HeaderFront,
        'content-page': ContentFront,
        'register': Register,
        'login': Login,
        'reset': Reset,
        'recovery': Recovery,
    },
    // computed: {
    //   ...mapState({
    //     activeFront: state => state.activeFront,
    //   })
    // },
    data() {
        return {
            active: 'login',
            username: null,
            password: null,
            data: null,
        }
    },
    methods: {
        setActive(item) {
          this.active = item;
        },
        login() {
            let vm = this;
            this.$validator.validateAll()
                .then(result => {
                    if (result) {
                        const apiData = {
                            username: this.username,
                            password: this.password
                        }
                        axios.post(process.env.hostname + '/oauth/token', apiData)
                            .then(response => {
                                vm.data = response;
                                this.$auth.setToken(response.data.token_type + ' ' + response.data.access_token, response.data.expires_in + Date.now());
                                this.$router.push('/dashboard')
                            });
                    }
                })
        },
        setLocale: function (lang) {
          localStorage.setItem('locale', lang);
          this.$i18n.locale = lang;
        }
    }
}
</script>

<style lang="scss">
main.guest-main {
    margin-left: 0;
    padding: 0;
}
.container-fluid {
    padding: 0 7px;
}
.bottom-links {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  font-size: 13px;
  a {
    display: flex;
    &:hover {
      text-decoration: none;
    }
    i {
      margin-right: 5px;
    }
  }
}
.front-container-inner {
  max-width: 500px;
  width: 90%;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0 0 3px -2px black;
  border-radius: 5px;
  padding: 50px;
}

.logo {
  /*margin-right: 84px;*/
  margin: 0 auto;
  width: 200px;
  height: 115px;
  background-image: url("../../assets/img/logo.png");
  background-size: 100% 100%;
}

@media screen and (max-width: 500px) {
  .header {
    .search-form {
      .row {
        div {
          select {
            color: black;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .search-form {
    .row {
      div {
        margin: 10px auto;
      }
    }
  }

  #navbarSupportedContent {
    max-width: 100%;

    * {
      max-width: 100%;
    }
  }
}

@media screen and (max-width: 992px) {
  #navbarSupportedContent {
    padding: 10px;
    background: rgba(0, 0, 0, 0.83);
    position: absolute;
    top: 62px;
    right: 0;
  }
}

.input-field {
  background: none;
  outline: none;
  border: none;
  border-radius: 0;
  border-bottom: 2px solid #3da0d8;
}

.button {
  cursor: pointer;
  border-radius: 0;
  background: #3da0d8;
  color: white;
}

.header {
  position: relative;
  // background-image: url("../../assets/img/header.png");
  background-size: cover;
  background-position: center;

  .container {
    * {
      color: white;
    }

    position: inherit;
    z-index: 1;

    .logo {
      /*margin-right: 84px;*/
      width: 85px;
      height: 51px;
      background-image: url("../../assets/img/logo-inverse.png");
      background-size: 100% 100%;
    }

    .search {
      width: 500px;
      position: relative;

      li {
        width: 100%;

        input {
          width: 100%;
          border: 1px solid #3da0d8;
          color: #3da0d8;
          border-radius: 0;
        }

        .btn-search {
          position: absolute;
          top: 0;
          right: 0;
          background: none;
          cursor: pointer;

          i {
            color: #3da0d8;
          }
        }
      }
    }
  }

  .search-form {
    max-width: 500px;
    margin-top: 100px;

    input {
      @extend .input-field;
      /*font-size:12px;*/
      color: white;
    }

    button {
      @extend .button;
    }
  }

  .header-title {
    font-size: 24px;
    max-width: 500px;
    margin-top: 25px;
  }

  .btn-left {
    max-width: 500px;

    i {
      font-size: 30px;
    }

    a {
      padding: 5px 10px;

      &:nth-child(2) {
        border-right: 1px solid white;
      }

      &:hover {
        color: #3da0d8;
        text-decoration: none;
      }
    }
  }

  .shade {
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 50%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .modal {
    .modal-content {
      .register-btn {
        @extend .button;
      }

      border-radius: 0;

      .login-logo {
        margin-top: 40px;

        i {
          font-size: 100px;
          color: #3da0d8;
        }

        .login-title {
          margin-top: 5px;
          color: #b1b1b1;
        }
      }

      .register-logo {
        margin-top: 40px;

        i {
          font-size: 60px;
          color: #3da0d8;
        }

        p {
          color: #3da0d8;
        }

        .login-title {
          margin-top: 5px;
          color: #3da0d8;
        }
      }

      .login-form {
        margin-top: 40px;
        margin-bottom: 100px;

        .form-control {
          @extend .input-field;
          color: #3da0d8;
        }

        .login-buttons {
          * {
            &:hover {
              text-decoration: none;
            }
          }

          .login-btn {
            @extend .button;
          }

          div {
            &:first-child {
              p {
                margin-bottom: 3px;
                font-size: 14px;
              }

              h4 {
                color: #b1b1b1;
                text-align: left;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}

.localisation {
  a {
    cursor: pointer;
  }

  .dropdown-menu {
    right: 0 !important;
    left: auto;

    a {
      display: block;
      color: black;
    }
  }
}

.gray {
  color: #b2b2b1;
}
</style>



// WEBPACK FOOTER //
// src/components/frontpage/FrontPage.vue